import type { CmsAsset, RichTextContent } from '../../types/contentstack'
import type { VideoContentSectionFields } from './types'

const PLACEHOLDER_VIDEO_URL =
  'https://images.ctfassets.net/awpxl2koull4/2H7QjuhbkJMgYukzDkdpOG/3bb1d66fb0451c73fe14f8d458663299/how-it-works.mp4'

const PLACEHOLDER_POSTER_URL =
  'https://eu-images.contentstack.com/v3/assets/blt249ad47e3410b9aa/bltf10b9205f4494730/69c539e5a3472f1f9f3236bb/george.jpeg'

const createAsset = (overrides: Partial<CmsAsset>): CmsAsset => ({
  uid: 'asset',
  url: PLACEHOLDER_POSTER_URL,
  title: 'Video content section asset',
  filename: 'asset.jpg',
  content_type: 'image/jpeg',
  ...overrides,
})

const body: RichTextContent = {
  type: 'doc',
  uid: 'video-content-section-body-doc',
  attrs: {},
  children: [
    {
      type: 'p',
      uid: 'video-content-section-body-p1',
      attrs: {},
      children: [
        {
          text: 'See how Gousto recipes make weeknight cooking simple.',
        },
      ],
    },
  ],
} as unknown as RichTextContent

export const videoContentSectionMockData: VideoContentSectionFields = {
  heading: 'Simple dinners, step by step',
  heading_level: 'h2',
  body,
  video: createAsset({
    uid: 'video-content-section-video',
    url: PLACEHOLDER_VIDEO_URL,
    title: 'How Gousto works video',
    filename: 'how-it-works.mp4',
    content_type: 'video/mp4',
  }),
  poster_image: createAsset({
    uid: 'video-content-section-poster',
    title: 'How Gousto works poster image',
    filename: 'how-it-works-poster.jpg',
    content_type: 'image/jpeg',
  }),
  captions: createAsset({
    uid: 'video-content-section-captions',
    url: 'https://example.com/how-it-works.vtt',
    title: 'How Gousto works captions',
    filename: 'how-it-works.vtt',
    content_type: 'text/vtt',
  }),
  cta: {
    text: 'View the menu',
    variant: 'primary',
    url: '/menu',
  },
}
